// extracted by mini-css-extract-plugin
export var container = "_99-0";
export var containerTopRight = "_99-1";